import React from 'react';
import { useTranslation } from 'react-i18next';
import { ClinicLocationWithAnalytics } from '../common/model/dto/clinic-location';
import { RecordColumn } from '../common/model/ui/record-list.type';
import DateUtils from '../common/utils/services/date-utils';
import StringUtils from '../common/utils/services/string-utils';
import OvPillLink from '../components/UI/atoms/OvPillLink';
import OvRecordCount from '../components/UI/atoms/OvRecordCount';

export function useClinicLocationListColumns(
  getNavigationState: () => unknown
): RecordColumn<ClinicLocationWithAnalytics>[] {
  const { t } = useTranslation();

  return [
    {
      id: 'name',
      header: t('common.clinicLocationFields.name'),
      cardRole: 'heading',
      renderCell: (location) => StringUtils.displayValue(location.name ?? ''),
    },
    {
      id: 'email',
      header: t('common.clinicLocationFields.email'),
      renderCell: (location) => StringUtils.displayValue(location.email ?? ''),
    },
    {
      id: 'city',
      header: t('common.clinicLocationFields.city'),
      renderCell: (location) => StringUtils.displayValue(location.city ?? ''),
    },
    {
      id: 'phone',
      header: t('common.clinicFields.phone1'),
      renderCell: (location) => StringUtils.displayValue(location.phone1 ?? ''),
    },
    {
      id: 'providers',
      header: t('common.clinicFields.providers'),
      renderCell: (location) => (
        <OvRecordCount value={location.clinic_location_provider_count} />
      ),
    },
    {
      id: 'patients',
      header: t('common.clinicFields.patients'),
      renderCell: (location) => (
        <OvRecordCount value={location.clinic_location_patient_count} />
      ),
    },
    {
      id: 'created-at',
      header: t('common.createdAt'),
      renderCell: (location) =>
        StringUtils.displayValue(
          DateUtils.formatDate(
            location.created_at,
            'MMMM DD, YYYY, HH:mm:ss'
          ) || ''
        ),
    },
    {
      id: 'action',
      header: t('common.action'),
      isHeaderHidden: true,
      cardRole: 'footer',
      renderCell: (location, detailsPath = '') => (
        <OvPillLink
          to={detailsPath}
          state={getNavigationState()}
          aria-label={t('clinicLocationDetails.detailsFor', {
            name: location.name,
          })}
        >
          {t('common.actions.seeDetails')}
        </OvPillLink>
      ),
    },
  ];
}
